import { BrowserRouter } from 'react-router-dom';

import AppErrorBoundary from './components/AppErrorBoundary';
import AppRoutes from './routes/AppRoutes';
import useUserSessionContext from './hooks/contexts/useUserSessionContext';
import AppLoadingIndicator from './components/AppLoadingIndicator';

const App = () => {
  const { isReady } = useUserSessionContext();

  return (
    <BrowserRouter>
      <AppErrorBoundary>
        {isReady ? <AppRoutes /> : <AppLoadingIndicator isFullScreen />}
      </AppErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
